import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'na' })
export class TableNaPipe implements PipeTransform {
  public transform(value: string): string {
    if (value.length === 0 || value === null) return 'N/A';
    else return value;
  }
}
